import { axiosInstance } from './axios';
import type { ApiResponse, PaginatedResponse } from '../../types/common';
import type {
  MyTicketListDto,
  MyTicketDetailDto,
  SupportModuleDto,
  CreateTicketPayload,
  AddCommentPayload,
  RateTicketPayload,
  GetMyTicketsParams,
} from '../../types/support';

const BASE = '/v1/support-tickets';

export interface UploadUrlDto {
  uploadUrl: string;
  blobPath: string;
}

export const supportService = {
  getModules: () =>
    axiosInstance.get<ApiResponse<SupportModuleDto[]>>(`${BASE}/modules`),

  getMyTickets: (params?: GetMyTicketsParams) =>
    axiosInstance.get<PaginatedResponse<MyTicketListDto>>(BASE, { params }),

  getTicketDetail: (id: number) =>
    axiosInstance.get<ApiResponse<MyTicketDetailDto>>(`${BASE}/${id}`),

  createTicket: (payload: CreateTicketPayload) =>
    axiosInstance.post<ApiResponse<number>>(BASE, payload),

  addComment: (id: number, payload: AddCommentPayload) =>
    axiosInstance.post<ApiResponse<number>>(`${BASE}/${id}/comments`, payload),

  reopenTicket: (id: number) =>
    axiosInstance.put<ApiResponse<void>>(`${BASE}/${id}/reopen`),

  rateTicket: (id: number, payload: RateTicketPayload) =>
    axiosInstance.put<ApiResponse<void>>(`${BASE}/${id}/rate`, payload),

  getAttachmentUrl: (blobPath: string, fileName?: string) =>
    axiosInstance.get<ApiResponse<string>>('/v1/support-tickets/attachment-url', { params: { blobPath, fileName } }),

  getUploadUrl: (contentType: string) =>
    axiosInstance.post<ApiResponse<UploadUrlDto>>('/v1/Institutes/upload-url', {
      moduleName: 'support',
      contentType,
    }),

  uploadFileDirect: async (uploadUrl: string, file: File): Promise<void> => {
    const res = await fetch(uploadUrl, {
      method: 'PUT',
      headers: { 'Content-Type': file.type },
      body: file,
    });
    if (!res.ok) throw new Error(`Upload failed: ${res.status} ${res.statusText}`);
  },
};
